import React, { Fragment, useRef } from 'react';
import { GoogleMap, Marker, Polyline } from '@react-google-maps/api';
import GoogleMapContainer from '../map/GoogleMapContainer';
import { averageGeolocation } from '../../utils/mapUtils';
import { map } from './mapStyles';

import MARKER from '../../static/assets/Marker_Green.png';

function DriveMap({ places = [], zoom, loadingElement }) {
  const mapCenter = useRef(
    places.length
      ? averageGeolocation(
          places.map(p => ({
            lat: p.latitude,
            lng: p.longitude
          }))
        )
      : { lat: 47.577545, lng: -122.165115 }
  );

  const path = () =>
    places.map(p => ({
      lat: p.latitude,
      lng: p.longitude
    }));

  return (
    <GoogleMapContainer loadingElement={loadingElement}>
      <GoogleMap
        center={mapCenter.current}
        zoom={zoom}
        options={{ styles: map }}
      >
        <>
          <Polyline
            path={path()}
            options={{
              geodesic: true,
              strokeColor: '#e20074',
              strokeOpacity: 1.0,
              strokeWeight: 2
            }}
          />

          {places.map((place, index) => (
            <Fragment key={index}>
              {(index === 0 || index === places.length - 1) && (
                <Marker
                  key={index}
                  position={{
                    lat: place.latitude,
                    lng: place.longitude
                  }}
                  icon={{
                    url: MARKER,
                    labelOrigin: { x: 10, y: 12 }
                  }}
                  label={index === 0 ? 'Start' : 'End'}
                />
              )}
            </Fragment>
          ))}
        </>
      </GoogleMap>
    </GoogleMapContainer>
  );
}

export default DriveMap;
